var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-12 text-center"},[_c('el-empty',{staticStyle:{"margin-top":"10%"},attrs:{"description":"Page Not Found"}},[_c('h2',{staticStyle:{"margin-top":"-10px"}},[_vm._v("404")]),_c('br'),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("Go Back")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }